// Inter SemiBold is not in Mapbox's shared font library, and the basemap styles are mapbox-owned,
// so their `glyphs` template resolves to a shelf we cannot upload to. The face lives in our own
// accounts and only its glyph request is redirected there.
//
// Scoped to that one fontstack: unscoped, the basemap's own glyphs would go to our account too,
// which serves only what we hold. The account is read off the TOKEN rather than configured,
// because environments do not share one.
//
// A composite fontstack silently drops a face it cannot find rather than failing, so a missing
// upload means the wrong face, never a blank map.
const MAPBOX_FONTS_PATH = '/fonts/v1/mapbox/'
const REDIRECTED_FONT = 'Inter SemiBold'

// pk tokens are `<marker>.<base64url payload>.<sig>`; the payload's `u` claim is the account.
export function mapboxAccountFromToken(token: string): string | null {
  const payload = token?.split('.')[1]
  if (!payload) {
    return null
  }
  try {
    const json = atob(payload.replace(/-/g, '+').replace(/_/g, '/'))
    const account = JSON.parse(json)?.u
    return typeof account === 'string' && account ? account : null
  } catch {
    return null
  }
}

export function rewriteGlyphUrl(url: string, token: string): string | null {
  if (!url.includes(MAPBOX_FONTS_PATH)) {
    return null
  }
  // The fontstack sits in the path, so it arrives percent-encoded.
  if (!decodeURIComponent(url).includes(REDIRECTED_FONT)) {
    return null
  }
  const account = mapboxAccountFromToken(token)
  return account
    ? url.replace(MAPBOX_FONTS_PATH, `/fonts/v1/${account}/`)
    : null
}
